export default "__VITE_ASSET__joyOses3__"